{#if settingsController.isFieldVisible(fieldId)}
    <TextField
        {id}
        {label}
        bind:value
        maxlength="64"
        {type}
        placeholder=""
        required="{settingsController.isFieldRequired(fieldId)}"
        disabled="{!settingsController.isFieldEditable(fieldId)}"
        {autocomplete}
        {errorMessage}
        {hasError}
        on:blur
    />
{/if}

<script>
    import TextField from '@itslearning/prometheus/assets/inputs/TextField/v1/TextField.svelte';
    import { fromFieldSettingsController } from '../../formFieldSettingsController';
    
    export let id;
    export let label;
    export let value;
    export let type = 'text';
    export let fieldId;
    export let settings = {};
    export let autocomplete = "off";
    export let errorMessage = null;
    export let hasError = false;

    $: settingsController = fromFieldSettingsController(settings);
</script>